import { MYACCOUNT_URL } from '../../../../config';

const config = {
  MyAccountURL: MYACCOUNT_URL || 'https://account.now.com/MyAccount/',
};

export default config;